import moment from 'moment'
import { Table } from 'react-bootstrap'
import Dollars from '../../../../templates/Dollars/Dollars'
import { useAuth, useProtectedContent } from '../../../../context/AuthContext'
import useCallApi from '../../../../hooks/useCallApi'

const InvoiceInfo = ({ invoiceFrequency, paymentTerms, balances, limitedCreditFlag, invoiceDelay, invoiceDelayInterval, advertiserId, qbBalance }) => {
    const auth = useAuth()
    const showFullBalance = useProtectedContent(auth.permissions, 'advertiser_balances_full')

  const { dataLoaded: outstandingDataLoaded, data: outstandingData, refetch: outStandingRefetch } = useCallApi(`advertisers/outstandingInvoices?advertiserId=${advertiserId}`, 'GET', {}, [])

    const getInvoiceFrequency = (letter) => {
        if (letter === 'W') {
            return 'Weekly'
        } else if (letter === 'S') {
            return 'Semi-Monthly'
        } else if (letter === 'M') {
            return 'Monthly'
        } else if (letter === 'A') {
            return 'Ad-Hoc'
        } else {
            return 'Unknown'
        }
    }

    const isRed = (value) => {
        if (value < 0) {
            return 'text-danger'
        } else {
            return ''
        }
    }

    return (
        <div>
            <div className="p-2 d-flex" style={{ backgroundColor: 'rgba(0,0,0,.03)' }}>
                <div className="mr-3">
                    <div>Invoice Frequency</div>
                    <div className="font-weight-bold">{getInvoiceFrequency(invoiceFrequency)}</div>
                </div>                
                <div className="ml-3">
                    <div>Payment Terms </div>
                    <div className="font-weight-bold">{paymentTerms === -1 ? 'Pre-Pay' : `Net ${paymentTerms}`}</div>
                </div>
                {
                    invoiceDelay > 0 &&         
                        <div className="ml-3">
                            <div>Invoice Delay</div>
                            <div className="font-weight-bold ">{`${invoiceDelay} ${invoiceDelayInterval === 'W' ? 'week(s)' : 'day(s)'} from end of month.`}</div>
                        </div>
                }
                <div className="ml-3">
                    <div>QuickBooks Balance</div>
                    <div className="font-weight-bold">
                        {qbBalance != null ? <Dollars value={qbBalance} /> : '—'}
                    </div>
                </div>
            </div>
            {outstandingDataLoaded && outstandingData && outstandingData.success && outstandingData.data.length > 0 &&
                <table className="table table-card table-hover mb-0">
                    <thead>
                        <tr>
                            <th className="text-left">Outstanding Invoices</th>
                            <th className="text-right">Amount</th>
                            <th className="text-center">Due Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {outstandingData.data.map((invoice, index) => (
                            <tr key={index}>
                                <td align="left">{invoice.invoice_num}</td>
                                <td align="right" className={isRed(invoice.amount)}><Dollars value={invoice.amount} /></td>
                                <td align="center" className={moment().isAfter(moment(invoice.due_date).utc()) ? 'text-danger' : ''}>{invoice.due_date ? moment(invoice.due_date).utc().format('YYYY-MM-DD') : 'N/A'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
                       
            {limitedCreditFlag === 'Y' &&
                (showFullBalance ? (
                    <div className="m-2">
                        <Table striped bordered hover className="mt-2">
                            <thead>
                                <tr>
                                    <th>Source</th>
                                    <th className="text-right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Quickbooks balance{balances.balance_date ? ` as of ${moment(balances.balance_date).utc().format('YYYY-MM-DD')}` : ''}</td>
                                    <td align="right" className={isRed(balances.qb_balance * -1)}>                                        
                                        <Dollars value={balances.qb_balance * -1} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Leads{balances.balance_date ? ` as of ${moment(balances.balance_date).utc().format('YYYY-MM-DD')}` : ''}</td>
                                    <td align="right" className={isRed(balances.amount_since_balance_date * -1)}>                                        
                                        <Dollars value={balances.amount_since_balance_date * -1} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Paid invoices after reconciliation</td>
                                    <td align="right" className={isRed(balances.paid_invoices_since_balance_date)}>
                                        <Dollars value={balances.paid_invoices_since_balance_date} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Reversals for previous months done after the reconciliation date</td>
                                    <td align="right">
                                        <Dollars value={balances.reversals_before_balance_date} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bold">Balance {(balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date) * -1 < 0 ? <span className="text-danger">(owing)</span> : ''}</td>
                                    <td align="right" className={`font-weight-bold ${isRed((balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date) * -1)}`}>
                                        <Dollars value={(balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date)*-1} />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div className="m-2">
                        <Table striped bordered hover className="mt-2">
                            <tbody>
                                <tr>
                                    <td className="font-weight-bold">Balance {balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date > 0 ? <span className="text-danger">(owing)</span> : ''}</td>
                                    <td align="right" className={isRed(balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date)}>
                                        {balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date > 0 ? '-' : ''} <Dollars value={balances.final_balance - balances.paid_invoices_since_balance_date - balances.reversals_before_balance_date} />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                ))}
        </div>
    )
}

export default InvoiceInfo
